import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Button,
  ListItemSecondaryAction
} from "@material-ui/core";
import { RemoveCircle, Edit } from "@material-ui/icons";
import UserGroupDetail from "../UserGroupDetail";
import UserGroupStore from "../../stores/UserGroupStore";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class UserGroups extends React.Component {
  state = {
    groups: [],
    showModal: -1,
    open: false
  };
  componentDidMount() {
    document.title = "GO | Grupos de usuario";
    UserGroupStore.list().then(r => {
      this.setState({ groups: r.data, selected_id: 0 });
    });
  }
  onNew = e => {
    this.setState(ps => {
      return {
        showModal: 0,
        groups: [{ id: 0, short_name: "", long_name: "" }, ...ps.groups]
      };
    });
  };

  openModal = group_id => {
    this.setState({ showModal: group_id });
  };

  closeModal = (e, res) => {
    this.setState(ps => {
      const ns = { ...ps, showModal: -1 };
      if (res.type === "new") {
        const index = ps.groups.findIndex(e => e.id === res.old_id);
        ns.groups[index].id = res.new_id;
      } else if (res.type === "cancel") {
        ns.groups.splice(0, 1);
      }
      return ns;
    });
  };

  handleClickOpen = (e) => {
    this.setState({ open: true, selected_id: e});
  };

  handleClose = () => {
    this.setState({ open: false, selected_id: 0 });
  };

  onDelete = group => {
    UserGroupStore.delete(group).then(r => {
      this.setState(ps => {
        const ns = { ...ps };
        const index = ps.groups.findIndex(e => e.id === group.id);
        ns.groups.splice(index, 1);
        return ns;
      });
    });
    this.handleClose();
  };

  onChange = group => {
    this.setState(ps => {
      const ng = [...ps.groups];
      let index = ng.findIndex(v => {
        return v.id === group.id;
      });
      ng[index] = group;
      return { groups: ng };
    });
  };

  render() {
    const { groups, showModal } = this.state;
    return (
      <Grid container>
        <Grid item lg={12} md={12} sm={12} className="grid_groups">
          <List>
            {groups.map(g => (
              <React.Fragment key={g.id}>
                <ListItem>
                  <ListItemText
                    primary={g.short_name}
                    secondary={g.long_name}
                  />
                  <ListItemSecondaryAction>
                      <IconButton onClick={(e) => this.handleClickOpen(g)} disabled={((g.sents === 0 || g.sents === undefined) && (g.notices === 0 || g.notices === undefined))? false : true}>
                        <RemoveCircle />
                      </IconButton>
                    <IconButton onClick={e => this.openModal(g.id)}>
                      <Edit />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <UserGroupDetail
                  group={g}
                  onChange={this.onChange}
                  open={showModal === g.id}
                  onClose={this.closeModal}
                />
              </React.Fragment>
            ))}
          </List>
        </Grid>
        <Grid container justify="flex-end" style={{ marginBottom: "1rem", textAlign: "right" }}>
          <Grid item lg={2} md={2} sm={2}>
            <Button color="primary" variant="contained" onClick={this.onNew}>
              Agregar
            </Button>
          </Grid>
        </Grid>
        <Dialog
         open={this.state.open}
         onClose={this.handleClose}
       >
         <DialogTitle id="draggable-dialog-title">Confirmación</DialogTitle>
         <DialogContent>
             ¿Realmente desea eliminar el grupo?
         </DialogContent>
         <DialogActions className="button_modal">
           <Button onClick={this.handleClose} color="primary">
             Cancelar
           </Button>
           <Button onClick={() => this.onDelete(this.state.selected_id)} color="primary">
             Eliminar
           </Button>
         </DialogActions>
       </Dialog>
      </Grid>
    );
  }
}

UserGroups.propTypes = {};
export default UserGroups;



// WEBPACK FOOTER //
// ./src/components/containers/UserGroups.js